import { useI18N } from '@shared-core/hooks/use-i18n'
import { AppIcon } from '@shared-ui/components/ui/app-icon'
import { Button } from '@shared-ui/components/ui/button'
import { Column } from '@shared-ui/components/ui/grid'
import { GText } from '@shared-ui/components/ui/text'
import { useWideDesktopLayout } from '@shared-ui/hooks/use-wide-desktop-layout'
import { Modal, Pressable, ScrollView, View } from 'react-native'
import locales from './index.i18n.json'
import { useCreateStyles } from './styles'

export type AppCardFreezeSheetProps = {
  isVisible: boolean
  state: { isFrozen: boolean; isLoading: boolean; isError: boolean }
  onConfirm: () => void
  onClose: () => void
  testID?: string
}

export function AppCardFreezeSheet({ isVisible, state, onConfirm, onClose, testID }: AppCardFreezeSheetProps) {
  const { isFrozen, isLoading, isError } = state
  const styles = useCreateStyles()
  const isDesktop = useWideDesktopLayout()
  const { t } = useI18N(locales)
  return (
    <Modal visible={isVisible} transparent animationType="fade" onRequestClose={onClose} statusBarTranslucent>
      <View style={[styles.overlay, isDesktop && styles.overlayDesktop]}>
        <Pressable style={styles.backdrop} onPress={onClose} accessibilityLabel={t('close')} />
        <ScrollView
          style={[styles.sheet, isDesktop && styles.sheetDesktop]}
          contentContainerStyle={styles.content}
          testID={testID}
        >
          <Pressable style={styles.close} onPress={onClose} accessibilityRole="button" accessibilityLabel={t('close')}>
            <AppIcon icon="close" size={24} />
          </Pressable>
          <Column gap={32}>
            <Column gap={16}>
              <GText fw={600} style={styles.title}>
                {t(isFrozen ? 'unfreeze-title' : 'freeze-title')}
              </GText>
              <GText style={styles.description}>{t(isFrozen ? 'unfreeze-description' : 'freeze-description')}</GText>
            </Column>
            {isError && <GText style={styles.error}>{t('error')}</GText>}
            <Button
              theme="black"
              style={styles.button}
              disabled={isLoading}
              isLoading={isLoading}
              onPress={onConfirm}
              testID="card-freeze-confirm"
            >
              {t(isFrozen ? 'unfreeze' : 'freeze')}
            </Button>
          </Column>
        </ScrollView>
      </View>
    </Modal>
  )
}
